import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../lib/translations";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        if (typeof window !== "undefined") {
            return localStorage.getItem("mmbr_lang") || "da";
        }
        return "da";
    });

    useEffect(() => {
        if (typeof window !== "undefined") {
            localStorage.setItem("mmbr_lang", lang);
            document.documentElement.lang = lang;
        }
    }, [lang]);

    const t = translations.da;

    return (
        <LangContext.Provider value={{ lang: "da", setLang, t }}>
            {children}
        </LangContext.Provider>
    );
};

export const useLang = () => {
    const ctx = useContext(LangContext);
    if (!ctx) throw new Error("useLang must be used within LangProvider");
    return ctx;
};
